import { Component } from '@angular/core';

@Component({
  selector: 'app-app-loader',
  imports: [],
  templateUrl: './app-loader.component.html',
  styleUrl: './app-loader.component.css'
})
export class AppLoaderComponent {

}
